// test2066
(2066 && 0);
